"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TARGET = exports.SPACES = exports.SIZES = exports.PARA_TYPE = exports.DEVICE = exports.CONTAINER_WIDTH = exports.COLORS = exports.BUTTON_TYPE = void 0;
var TARGET = {
  tab: 'tab',
  self: 'self',
  parent: 'parent'
};
exports.TARGET = TARGET;
var BUTTON_TYPE = {
  BUTTON: 'button',
  LINK: 'link',
  BUTTON_WIDTH_DESKTOP: '120px',
  BUTTON_FULL_WIDTH: '100%'
};
exports.BUTTON_TYPE = BUTTON_TYPE;
var COLORS = {
  GREY_DARKER: 'greyDarker',
  GREY_DARK: 'greyDark',
  DEFAULT: 'default',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  PRIMARY_DARK: 'primaryDark',
  GREY_LIGHTER: 'greyLighter'
};
exports.COLORS = COLORS;
var SIZES = {
  SMALL: 'small',
  NONE: 'none',
  NORMAL: 'normal',
  TINY: 'tiny',
  STANDARD: 'standard',
  XSMALL: 'XSmall'
};
exports.SIZES = SIZES;
var DEVICE = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop'
};
exports.DEVICE = DEVICE;
var SPACES = {
  DESKTOP: '24px',
  MOBILE: '16px'
};
exports.SPACES = SPACES;
var CONTAINER_WIDTH = {
  DESKTOP: '440px',
  MOBILE: '95% !important'
};
exports.CONTAINER_WIDTH = CONTAINER_WIDTH;
var PARA_TYPE = {
  BULLET: 'bullet'
};
exports.PARA_TYPE = PARA_TYPE;